module.exports = __webpack_public_path__ + "media/images/class_notes_cover-48b018ad12aa332a0ef6c5bfba45065a.png";